module.exports = __webpack_public_path__ + "static/media/icn_mainnav_discover_small.8b480b39.svg";